import React from "react";
import { dummyClick } from "../utilities";
import clsx from "clsx";

const Episode = ({ children, onClick, className }) => (
  <div className={clsx("scrollreader", className)} onClick={onClick}>
    {children}
  </div>
);

Episode.defaultProps = {
  onClick: dummyClick
};

export { Episode };
